module.exports = __webpack_public_path__ + "img/erwei-code.ee25900e.png";